<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.queryCommodityGoodsList"
      :placeholder="placeholder"
      :immediate="immediate"
      :keys="{ searchKey: 'commodityName', nameKey: 'goodsName' }"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择物品',
    },
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
    };
  },
});
</script>
